import type { ReactNode } from 'react';

import { cn } from '../../../../lib/cn';
import { docDoan, tachDoan, tachManh, type KhoiDoan, type Manh } from '../../nghiep-vu/loi-van';

/**
 * Lời văn của trợ lý, vẽ đúng những gì lời nhắc cho phép nó sinh ra (port `components/ai/LoiVan.tsx` native).
 *
 * Bản cũ vẽ thẳng `{answer}` nên người đọc thấy nguyên dấu sao và các đoạn dính liền thành một khối — đoạn được tách
 * theo CHỨC NĂNG (câu trả lời, điểm đáng chú ý, cảnh báo), dính lại là phần cảnh báo chìm giữa khối chữ. Phần tách chuỗi
 * ở `nghiep-vu/loi-van.ts`; ở đây chỉ dựng nút React, không có chuỗi HTML nào.
 */
export function LoiVan({ text, className }: { text: string; className?: string }) {
  const doan = tachDoan(text);
  if (!doan.length) return null;
  return (
    <div className={className}>
      {doan.map((d, i) => {
        const khoi = docDoan(d);
        return khoi ? <Doan key={i} khoi={khoi} dau={i === 0} /> : null;
      })}
    </div>
  );
}

function Doan({ khoi, dau }: { khoi: KhoiDoan; dau: boolean }) {
  const le = dau ? '' : 'mt-2.5';
  if (khoi.loai === 'bang') {
    return (
      <div className={cn('overflow-x-auto', le)}>
        <table className="w-full text-xs">
          <thead>
            <tr>
              {khoi.dau.map((c, i) => (
                <th key={i} scope="col" className="border-b border-default px-2 py-1 text-start font-semibold">
                  {veDong(c)}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {khoi.than.map((r, i) => (
              <tr key={i}>
                {r.map((c, j) => (
                  <td key={j} className="border-b border-default px-2 py-1 align-top">
                    {veDong(c)}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
  if (khoi.loai === 'cum') {
    return (
      <div className={le}>
        {khoi.cum.map((k, i) =>
          k.gach ? (
            <ul key={i} className="my-1 list-disc space-y-0.5 ps-5">
              {k.dong.map((d, j) => (
                <li key={j}>{veDong(d)}</li>
              ))}
            </ul>
          ) : (
            <p key={i} className={i ? 'mt-2.5' : ''}>
              {xuongDong(k.dong)}
            </p>
          ),
        )}
      </div>
    );
  }
  return <p className={le}>{xuongDong(khoi.dong)}</p>;
}

function xuongDong(dong: string[]): ReactNode {
  return dong.map((d, i) => (
    <span key={i}>
      {i ? <br /> : null}
      {veDong(d)}
    </span>
  ));
}

function veDong(s: string): ReactNode {
  return veManh(tachManh(s));
}

function veManh(ds: Manh[]): ReactNode {
  return ds.map((m, i) => {
    switch (m.loai) {
      case 'chu':
        return <span key={i}>{m.chu}</span>;
      case 'dam':
        return (
          <strong key={i} className="font-semibold">
            {veManh(m.manh)}
          </strong>
        );
      case 'nghieng':
        return <em key={i}>{veManh(m.manh)}</em>;
      case 'lien_ket':
        return (
          <span key={i}>
            {/* `noopener`: trang mở ra giữ `window.opener` là giữ được đường đổi địa chỉ của tab này. */}
            <a
              href={m.url}
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary-600 underline underline-offset-2 hover:text-primary-700"
            >
              {m.url}
            </a>
            {m.duoi}
          </span>
        );
      default:
        return null;
    }
  });
}
